module.exports = __webpack_public_path__ + "static/akkreditierung-75918772fcd49260207e918751c80b6e.jpg";